import { createMuiTheme } from 'material-ui/styles/index'

const primary = {
  50: '#cecbff',
  100: '#a19cef',
  200: '#a19cef',
  300: '#a19cef',
  400: '#6c4af8',
  500: '#6c4af8',
  600: '#6c4af8',
  700: '#464296',
  800: '#464296',
  900: '#464296',
  'A100': '#5d58f7',
  'A200': '#5d58f7',
  'A400': '#5d58f7',
  'A700': '#5d58f7',
  'contrastDefaultColor': 'light',
}

const secondary = {
  50: '#ffdec9',
  100: '#ffb89e',
  200: '#ffb89e',
  300: '#ffb89e',
  400: '#ff9168',
  500: '#ff9168',
  600: '#ff9168',
  700: '#bc6e45',
  800: '#bc6e45',
  900: '#bc6e45',
  'A100': '#ff9168',
  'A200': '#ff9168',
  'A400': '#ffba5f',
  'A700': '#ff4378',
  'contrastDefaultColor': 'light',
}

export const theme = createMuiTheme({
  typography: {
    fontFamily: '"Roboto", "Helvetica Neue", Helvetica, Arial, sans-serif',
  },
  palette: {
    primary: {
      lightest: primary[100],
      light: primary[300],
      main: primary[500],
      dark: primary[700],
      contrastText: '#FFF',
    },
    secondary: {
      lightest: secondary[100],
      light: secondary[300],
      main: secondary[500],
      dark: secondary[700],
    },
    gradient: {
      start: secondary['A700'],
      end: secondary['A400'],
    },
    border: 'rgb(212, 216, 224)',
    text: {
      primary: 'rgb(34, 34, 34)',
      secondary: 'rgb(91, 104, 124)',
    },
    background: {
      modal: 'rgb(247, 248, 248)',
    },
    pink: '#FF4378',
  },
})



// WEBPACK FOOTER //
// ./src/theme.js